export default () => ({
  qty: 1,
  price: null,
  formattedPrice: "",
  variantID: null,
  variantTitle: null,
  bundleID: null,
  closureID: null,
  closureTitle: "",
  logo: null,
  logoMessage: "",
  design: null,
  designMessage: "",
  card: null,
  cardID: null,
  cardMessage: "",
  cardTitle: "",
  message: "",
  loading: false,
  addressFile: null,
  foil: null,
  startVariant: "",

  options: null,
  variantData: null,
  currentVariantId: null,
  currentVariantAvailable: null,
  currentVariantTitle: null,
  productUrl: null,
  section: null,
  available: true,
  addToCartText: null,
  soldOutText: null,
  sizeOptionText: null,
  productHandle: null,
  productId: null,
  variantInventoryQuantity: null,
  variants: [],

  getLocale() {
    if (window.shopifyData && window.shopifyData.locale) {
      return window.shopifyData.locale;
    }
    const htmlLang = document.documentElement.lang;
    if (htmlLang) {
      return htmlLang;
    }
    return "sv-SE";
  },

  getCurrencySymbol() {
    if (window.shopifyData && window.shopifyData.currencySymbol) {
      return window.shopifyData.currencySymbol;
    }
    if (window.shopifyData && window.shopifyData.currency) {
      const currency = window.shopifyData.currency;
      if (["SEK", "DKK", "NOK"].includes(currency)) {
        return "kr";
      }
      return currency;
    }
    return "";
  },

  formatPrice(price) {
    try {
      const locale = this.getLocale();
      const currencySymbol = this.getCurrencySymbol();
      const numPrice = parseFloat(price) || 0;

      // If we don't have a locale, default to sv-SE for Nordic formatting
      const safeLocale = locale || "sv-SE";

      // If we don't have a currency symbol, default to kr for Nordic sites
      const safeCurrencySymbol = currencySymbol || "kr";

      const formattedNumber = numPrice.toLocaleString(safeLocale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      return `${formattedNumber} ${safeCurrencySymbol}`;
    } catch (error) {
      console.warn("Price formatting failed:", error);
      // Fallback to basic formatting if something goes wrong
      return `${parseFloat(price) || 0} kr`;
    }
  },

  initVariants(
    variantPrice,
    variantID,
    variantTitle,
    randomNumber,
    productUrl,
    startVariant,
    variantAvailable
  ) {
    // Wait for shopifyData to be available
    const initPrice = () => {
      this.price = variantPrice;
      this.formattedPrice = this.formatPrice(variantPrice);
      this.variantID = variantID;
      this.variantTitle = variantTitle;
      this.randomNumber = randomNumber;
      this.productUrl = productUrl;
      this.startVariant = startVariant;
      this.currentVariantId = variantID;
      this.currentVariantTitle = variantTitle;
      this.currentVariantAvailable = variantAvailable;
    };

    // If shopifyData is already available, initialize immediately
    if (window.shopifyData) {
      initPrice();
    } else {
      // Otherwise wait for DOMContentLoaded which is when shopifyData gets set
      document.addEventListener("DOMContentLoaded", initPrice, { once: true });
    }

    this.options = Array.from(
      this.$refs.variantPicker.querySelectorAll("input:checked"),
      (select) => select.value
    );
  },

  addProduct() {
    let formData = new FormData(this.$refs.product_form);
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        this.$dispatch("cart-updated");
        this.$dispatch("cart-toggle");
        this.loading = false;
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
  addExtra() {
    // Extra
    let items = [];

    if (this.cardID) {
      items.push({
        id: this.cardID,
        quantity: this.qty,
        properties: {
          Grupp: this.bundleID,
          Meddelande: this.cardMessage,
        },
      });
    }

    if (this.closureID) {
      items.push({
        id: this.closureID,
        quantity: this.qty,
        properties: {
          Grupp: this.bundleID,
        },
      });
    }

    if (this.design && this.startVariant !== "") {
      items.push({
        id: this.startVariant,
        quantity: 1,
        properties: {
          Grupp: this.bundleID,
        },
      });
    }

    if (items.length > 0) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: items }),
      })
        .then((response) => {
          this.addProduct();
        })
        .then((response) => {
          this.$dispatch("cart-updated");
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      this.addProduct();
    }
  },
  addToCart() {
    this.loading = true;
    this.addExtra();
  },
  optionChanged(option) {
    const values = option.data.split(":");
    this.variantID = values[0];
    this.variantTitle = values[1];
    this.price = values[2] && values[2];
    this.formattedPrice = this.formatPrice(this.price);

    window.history.replaceState({}, "", "?variant=" + this.variantID);
  },
  foilChanged(option) {
    this.foil = option.data;

    if (option) {
      localStorage.setItem("foil", JSON.stringify([option]));
    }
  },
  closureChanged(option) {
    const values = option.data.split(":");
    this.closureID = values[0];
    this.closureTitle = values[1];
  },

  updateOptions() {
    this.options = Array.from(
      this.$refs.variantPicker.querySelectorAll("input:checked"),
      (select) => select.value
    );

    this.updateMasterId();
    this.updateVariantInput();
    this.updateURL();
    // this.renderProductInfo();
    this.setAvailability();
  },

  updateMasterId() {
    let variantObj = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    this.currentVariantId = variantObj.id;
    this.currentVariantAvailable = variantObj.available;
    this.currentVariantTitle = variantObj.title;
    this.price = variantObj.price / 100;
    this.formattedPrice = this.formatPrice(this.price);
  },

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.$refs.variantPicker.querySelector('[type="application/json"]')
          .textContent
      );
    return this.variantData;
  },

  updateURL() {
    if (!this.currentVariantId) return;
    window.history.replaceState(
      {},
      "",
      `${this.productUrl}?variant=${this.currentVariantId}`
    );
  },
  setAvailability() {
    this.variants.forEach(
      function (arrayItem) {
        if (this.currentVariantId == arrayItem.id) {
          if (arrayItem.available) {
            this.currentVariantAvailable = arrayItem.available;
          }

          this.variantInventoryQuantity = arrayItem.quantity;
        }
      }.bind(this)
    );
  },

  setVariants(id, quantity, available) {
    this.variants.push({
      id: id,
      quantity: quantity,
      available: available,
    });
  },
  updateVariantInput() {
    const inputs = document.querySelectorAll('input[name="id"]');
    for (const input of inputs) {
      input.value = this.currentVariantId;
    }
  },

  isVariantAvailable(text) {
    const variantData =
      this.variantData ||
      JSON.parse(
        this.$refs.variantPicker.querySelector('[type="application/json"]')
          .textContent
      );
    const variant = variantData.find((variant) => variant.option2 === text);
    if (variant) {
      if (variant.available) {
        return true;
      }
      return false;
    }
  },
});
